package com.pincer.core.model.tree

import kotlinx.serialization.Serializable
import kotlin.js.JsName

@Serializable
data class Chat

(

    @JsName("principalId") var principalId : String,
    @JsName("wording")     var wording     : String,
    @JsName("edited")      var edited      : Boolean = false,
    @JsName("roles")       var roles       : String? = null,

)

{

    fun duplicate() = Chat(
        principalId = principalId,
        wording     = wording,
        edited      = edited,
        roles       = roles,
    )

}
